module.exports = __webpack_public_path__ + "static/spotify-f97fb74801d86c6928ca73cd1444850c.svg";